var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.7325 6.11644C12.7325 6.16744 12.3328 11.223 12.1044 13.3507C11.9615 14.6564 11.1197 15.4484 9.85713 15.4709C8.887 15.4926 7.93731 15.5001 7.00293 15.5001C6.01092 15.5001 5.0408 15.4926 4.09913 15.4709C2.87882 15.4416 2.03635 14.6339 1.90067 13.3507C1.6658 11.2155 1.27338 6.16744 1.26608 6.11644C1.25879 5.9627 1.30839 5.81645 1.40905 5.69795C1.50825 5.58846 1.65121 5.52246 1.80147 5.52246H12.2044C12.3539 5.52246 12.4896 5.58846 12.5968 5.69795C12.6967 5.81645 12.7471 5.9627 12.7325 6.11644",
    fill: "#FA4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 3.48265C13.75 3.17441 13.5071 2.93291 13.2153 2.93291H11.0286C10.5836 2.93291 10.197 2.61643 10.0978 2.17019L9.97528 1.62346C9.80387 0.962734 9.21231 0.5 8.54855 0.5H5.45218C4.78112 0.5 4.1954 0.962734 4.01743 1.65946L3.90291 2.17094C3.80298 2.61643 3.41639 2.93291 2.97217 2.93291H0.78539C0.492895 2.93291 0.25 3.17441 0.25 3.48265V3.76764C0.25 4.06837 0.492895 4.31737 0.78539 4.31737H13.2153C13.5071 4.31737 13.75 4.06837 13.75 3.76764V3.48265Z",
    fill: "#FA4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.ea80efe41e536d7768ed9f0225c65f9d.svg";
export { ForwardRef as ReactComponent };